export const setOidcAccessToken = (accessToken: string) => {
  sessionStorage.setItem("explorer.oidc.access_token", accessToken);
};

export const getOidcAccessToken: () => string | null = () => {
  return sessionStorage.getItem("explorer.oidc.access_token");
};
